import omitProps from '@hocs/omit-props';

export const withoutRouter = omitProps('history', 'location', 'match', 'staticContext');
